export default __webpack_public_path__ + "static/media/it900-a32-3.122b257e.jpg";